module.exports = __webpack_public_path__ + "img/stds_img.1d4c0327.png";